<div class="filters-skeleton" aria-hidden="true">
    <div class="filters-skeleton__header filters-skeleton__line"></div>

    <div class="filters-skeleton__hero">
        <div class="filters-skeleton__hero-card">
            <div class="filters-skeleton__hero-line filters-skeleton__line"></div>
        </div>
    </div>

    <div class="filters-skeleton__control">
        <div class="filters-skeleton__control-line filters-skeleton__line"></div>
    </div>

    <div class="filters-skeleton__divider"></div>

    <div class="filters-skeleton__row">
        <div class="filters-skeleton__row-line filters-skeleton__line"></div>
    </div>
    <div class="filters-skeleton__row">
        <div class="filters-skeleton__row-line filters-skeleton__line"></div>
    </div>
    <div class="filters-skeleton__row filters-skeleton__row_select">
        <div class="filters-skeleton__row-line filters-skeleton__line"></div>
        <span class="filters-skeleton__chevron"></span>
    </div>
    <div class="filters-skeleton__row filters-skeleton__row_select">
        <div class="filters-skeleton__row-line filters-skeleton__line"></div>
        <span class="filters-skeleton__chevron"></span>
    </div>
    <div class="filters-skeleton__row filters-skeleton__row_select">
        <div class="filters-skeleton__row-line filters-skeleton__line"></div>
        <span class="filters-skeleton__chevron"></span>
    </div>
    <div class="filters-skeleton__row filters-skeleton__row_select">
        <div class="filters-skeleton__row-line filters-skeleton__line"></div>
        <span class="filters-skeleton__chevron"></span>
    </div>
    <div class="filters-skeleton__row filters-skeleton__row_select">
        <div class="filters-skeleton__row-line filters-skeleton__line"></div>
        <span class="filters-skeleton__chevron"></span>
    </div>
    <div class="filters-skeleton__row filters-skeleton__row_select">
        <div class="filters-skeleton__row-line filters-skeleton__line"></div>
        <span class="filters-skeleton__chevron"></span>
    </div>
    <div class="filters-skeleton__row filters-skeleton__row_select">
        <div class="filters-skeleton__row-line filters-skeleton__line"></div>
        <span class="filters-skeleton__chevron"></span>
    </div>
    <div class="filters-skeleton__row filters-skeleton__row_select">
        <div class="filters-skeleton__row-line filters-skeleton__line"></div>
        <span class="filters-skeleton__chevron"></span>
    </div>
    <div class="filters-skeleton__row filters-skeleton__row_select">
        <div class="filters-skeleton__row-line filters-skeleton__line"></div>
        <span class="filters-skeleton__chevron"></span>
    </div>
    <div class="filters-skeleton__row filters-skeleton__row_select">
        <div class="filters-skeleton__row-line filters-skeleton__line"></div>
        <span class="filters-skeleton__chevron"></span>
    </div>
</div>
